import ProgressBar from '@/components/progress-bar/progress-bar';
import InsightCard from '../insights-card/insights-card';
import { Insight, InsightLanguageDistribution } from '@/services/dashboard-service/dashboard.service.types';
import { InsightsTitles } from '@/constants/insights.constants';
import { Flex, FlexProps } from 'antd';
import InsightsPieChart from '../insights-pie-chart/insights-pie-chart';
import ContentWrapper from '../content-wrapper/content-wrapper';
import { NoRecords } from '@/components/no-records/no-records';

interface InsightsDataWrapperProps {
  sumOfData: number;
  title: InsightsTitles;
  contentProps?: Partial<FlexProps>;
  sumForWidth: number;
  data?: Insight | InsightLanguageDistribution;
  vertical?: boolean;
  className?: string;
  isLoading?: boolean;
  bigChart?: boolean;
  indexValues?: boolean;
  tooltip?: string;
  onShowMoreButtonClick?: () => void;
}

export default function InsightsDataWrapper({
  data,
  tooltip,
  sumOfData,
  title,
  isLoading,
  className = '',
  bigChart,
  vertical = false,
  contentProps = {},
  indexValues = false,
  sumForWidth,
  onShowMoreButtonClick,
}: InsightsDataWrapperProps) {
  return (
    <InsightCard tooltip={tooltip} title={title} isLoading={isLoading}>
      {!!data && !!sumOfData ? (
        <Flex className={className}>
          {bigChart ? (
            <InsightsPieChart data={data} sumOfData={sumOfData} />
          ) : (
            <ProgressBar data={data} sumOfData={sumOfData} sumForWidth={sumForWidth} />
          )}
          <ContentWrapper
            indexValues={indexValues}
            vertical={vertical}
            wrapperProps={contentProps}
            content={data}
            sumOfData={sumOfData}
            isButton={!bigChart}
            onButtonClick={onShowMoreButtonClick}
          />
        </Flex>
      ) : (
        <NoRecords />
      )}
    </InsightCard>
  );
}
